<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">W9 Request</div>
    </template>

    <Section>
      <v-form 
        class="d-flex flex-column" style="row-gap: 12px"
        ref="form"
        v-model="isValid"
        @submit.prevent="submitClick"
      >
        <v-text-field 
          outlined dense validate-on-blur hide-details="auto"
          v-model="name" label="Full Name"
          :rules="[required]"
        />

        <v-text-field
          outlined dense validate-on-blur hide-details="auto"
          v-model="ssn" label="SSN"
          v-mask="'###-##-####'"
          :rules="[required, validSSN]"
        />

        <SimpleGoogleAutocomplete
          outlined dense persistent-placeholder clearable hide-details="auto"
          autocomplete="address_fields"
          placeholder="Your home address"
          country="us"
          :rules="[fullAddress]"
          @placechanged="updateAddressData"
          v-model="address_string"
        />


        <div class="d-flex" style="position: relative">
          <VueSignaturePad
            ref="signaturePad" 
            height="125px"
            class="rounded"
            style="border: black 1px solid; background-color: #EEEEEE;"
            :options="{ penColor: 'blue' }"
          />
          <v-icon 
            style="position: absolute; right: 0px;" 
            color="dark grey"
            class="ma-1"
            @click="resetSignature"
          >
            mdi-close-box
          </v-icon>
          <div
            v-if="signatureValid"
            style="font-size: 14px; position: absolute; bottom: 4px; width: 100%"
            class="text-center grey--text font-italic"
          >
            sign here
          </div>
          <div 
            v-else style="font-size: 14px; position: absolute; bottom: 4px; width: 100%"
            class="text-center red--text font-italic"
          >
            signature required
          </div>
        </div>

        <v-checkbox 
          v-model="certified"
          dense hide-details="auto"
          :rules='[is_certified]'
        >
          <template #label>
            <div>
              I certify that I have <router-link :to="{ name: 'legal/w-9-cert' }">read</router-link>
              and that all the information I have provided is true.
            </div>
          </template>
        </v-checkbox>

        <div class="mt-3 d-flex justify-center">
          <v-btn :disabled="loading || !isValid" color="primary" type="submit">Save</v-btn>
        </div>
      </v-form>
    </Section>
  </ContentPage>
</template>

<script>
import { ContentPage, Section } from '@/components/pages'
import { SimpleGoogleAutocomplete } from '@/components/inputs'

import { required } from '@/lib/validations'
import { mapActions } from 'vuex'

export default {
  name :'W9FormPage',

  components: { ContentPage, Section, SimpleGoogleAutocomplete },

  data: () => ({
    name: '',

    address_string: '',
    address: {
      place_id: '',
      street: '',
      city: '',
      state: '',
      zipcode: '',
    },

    ssn: '',

    isValid: false,
    loading: false,
    signatureValid: true,

    // validations
    is_certified: v => v || 'You must agree to continue',
    required,
    validSSN: v => v.match(/\d\d\d-\d\d-\d\d\d\d/) != null || 'expecting ###-##-####'
  }),

  computed: {
    // validation rules
    fullAddress() {
      if (this.address.place_id && this.address.street ) return true
      return  'Please choose a full street address'
    },
  },

  methods: {
    ...mapActions('auth', ['createW9']),

    resetSignature() {
      this.$refs.signaturePad.clearSignature()
    },

    async submitClick() {
      if (this.$refs.signaturePad.isEmpty()) {
        this.signatureValid = false
        this.$refs.form.validate()
        return
      }
      this.signatureValid = true

      if (this.$refs.form.validate()) {
        const { name, ssn } = this
        const { street, city, state, zipcode } = this.address
        
        const signature = this.$refs.signaturePad.saveSignature().data
        const payload = { name, street, city, state, zipcode, signature, ssn }

        this.loading = true

        const result = await this.createW9(payload)    
        if (result.ok) {
          this.$router.replace({ name: 'w9/thanks' })
        }

        this.loading = false
      }
    },

    updateAddressData(addressData) {
      this.address.place_id = addressData.place_id
      this.address.street = addressData.name
      this.address.city = addressData.locality
      this.address.state = addressData.administrative_area_level_1
      this.address.zipcode = addressData.postal_code
    },
  }
}
</script>

